import { Children, type ReactNode } from "react";
import { H2, isWeb, Separator, styled, withStaticProperties, YStack, type YStackProps } from "tamagui";
import { SettingItem } from "./SettingItem";
const SettingsWrapper = styled(YStack, {
  boc: "$color4",
  gap: "$5",
  f: 1
});
type SettingsItemsProps = Omit<YStackProps, "children"> & {
  children?: ReactNode;
};
function SettingsItems({
  children,
  ...rest
}: SettingsItemsProps) {
  const items = Children.toArray(children);
  return <YStack gap="$4" {...isWeb ? {
    m: "$4"
  } : {}} {...rest} data-sentry-element="YStack" data-sentry-component="SettingsItems" data-sentry-source-file="Settings.tsx">
      {items.map((child, i) => <YStack key={i}>
          {i > 0 ? <Separator boc="$borderColor" marginHorizontal="$4.5" bw="$0.25" mb="$4" /> : null}
          {child}
        </YStack>)}
    </YStack>;
}
const SettingsGroup = styled(YStack, {
  px: "$1.5",
  bg: "transparent",
  gap: "$2"
});
const SettingsTitle = styled(H2, {
  "$platform-web": {
    mx: "$6"
  },
  mx: "$4",
  py: "$4"
});
export const Settings = withStaticProperties(SettingsWrapper, {
  Item: SettingItem,
  Items: SettingsItems,
  Group: SettingsGroup,
  Title: SettingsTitle
});